module.exports = __webpack_public_path__ + "img/home_03.ce09ed04.png";